import React, { useCallback, useEffect, useState } from "react";
import { getMySessions } from "../customerApi";
import { useMyText } from "./text";
import { useLanguage } from "../../i18n/LanguageContext";
import { fmtAt } from "./format";
import { PageTop, LoadState } from "./parts";

// 결과 태그(§14-5 result): inquiry → 「문의 접수 No.X」, failed → 「답변 못 함」, 그 밖 → 「답변 완료」
export function ResultTag({ s }) {
    const tt = useMyText();
    if (s.result === "inquiry" && s.inquiry_id) return <span className="my-tag ch-chatbot">{tt("res.inquiry", { id: s.inquiry_id })}</span>;
    if (s.result === "failed") return <span className="my-tag st-cancel">{tt("res.failed")}</span>;
    return <span className="my-tag st-done">{tt("res.answered")}</span>;
}

// 「10/6 (화) 14:25 · 6개 메시지 · 한국어」 — 모르는 언어는 뺀다
export function sessionMeta(s, tt, lang) {
    const l = s.lang === "ko" || s.lang === "zh" ? tt(`lang.${s.lang}`) : null;
    return [fmtAt(s.started_at, lang), tt("log.msgs", { n: s.message_count || 0 }), l].filter(Boolean).join(" · ");
}

// 내 대화 기록 #log — 최근 90일
export default function ChatLogList({ go, customer }) {
    const tt = useMyText();
    const { lang } = useLanguage();
    const [rows, setRows] = useState([]);
    const [state, setState] = useState("loading");
    const load = useCallback(() => {
        setState("loading");
        getMySessions().then((l) => { setRows(l); setState("ok"); }).catch(() => setState("error"));
    }, []);
    useEffect(() => { load(); }, [load]);
    return (
        <div className="my-wrap">
            <PageTop title={tt("log.title")} desc={tt("log.desc")} customer={customer} onBack={() => go("")} />
            {state !== "ok" ? <LoadState state={state} onRetry={load} onList={() => go("")} />
                : rows.length === 0 ? <div className="my-empty">{tt("log.empty")}</div>
                    : rows.map((s) => (
                        <div key={s.id} className="my-log" role="button" tabIndex={0}
                            onClick={() => go(`log/${s.id}`)} onKeyDown={(e) => { if (e.key === "Enter") go(`log/${s.id}`); }}>
                            <div className="ic" aria-hidden="true">💬</div>
                            <div className="tx"><b>{s.first_message || tt("log.untitled")}</b><span>{sessionMeta(s, tt, lang)}</span></div>
                            <ResultTag s={s} />
                        </div>
                    ))}
        </div>
    );
}
